var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#9AB5E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 2,
    r: 2,
    fill: "#9AB5E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 2,
    r: 2,
    fill: "#9AB5E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 2,
    r: 2,
    fill: "#9AB5E7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 2,
    r: 2,
    fill: "#9AB5E7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 22,
    r: 2,
    fill: "#9AB5E7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 2,
    fill: "#9AB5E7"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 22,
    r: 2,
    fill: "#9AB5E7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 22,
    r: 2,
    fill: "#9AB5E7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 22,
    r: 2,
    fill: "#9AB5E7"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 42,
    r: 2,
    fill: "#9AB5E7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 42,
    r: 2,
    fill: "#9AB5E7"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 2,
    fill: "#9AB5E7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 42,
    r: 2,
    fill: "#9AB5E7"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 42,
    r: 2,
    fill: "#9AB5E7"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 62,
    r: 2,
    fill: "#9AB5E7"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 62,
    r: 2,
    fill: "#9AB5E7"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 62,
    r: 2,
    fill: "#9AB5E7"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 2,
    fill: "#9AB5E7"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 62,
    r: 2,
    fill: "#9AB5E7"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 82,
    r: 2,
    fill: "#9AB5E7"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 82,
    r: 2,
    fill: "#9AB5E7"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 82,
    r: 2,
    fill: "#9AB5E7"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 82,
    r: 2,
    fill: "#9AB5E7"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 2,
    fill: "#9AB5E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame1.9e8746a89b0208819e3e15813c61fcb5.svg";
export { ForwardRef as ReactComponent };